import { Controller } from '@hotwired/stimulus';

// Members card: switch between the "Actifs" and "Invités" tabs and show an
// inline confirmation row in place of a member/invitation row. The actual
// deactivate / reactivate / cancel actions stay plain button_to forms inside
// the confirmation row — this controller only toggles visibility.
export default class extends Controller {
  static targets = ['tab', 'panel', 'row'];

  switchTab(event) {
    const name = event.params.panel;
    this.closeAllConfirms();

    this.tabTargets.forEach((tab) => {
      tab.classList.toggle('ds-mbr-tab--active', tab.dataset.membersPanelParam === name);
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.membersPanel !== name;
    });
  }

  openConfirm(event) {
    const row = event.target.closest('[data-members-target="row"]');
    if (!row) return;

    this.closeAllConfirms();
    this.toggleRow(row, true);
  }

  closeConfirm(event) {
    const row = event.target.closest('[data-members-target="row"]');
    this.toggleRow(row, false);
  }

  closeAllConfirms() {
    this.rowTargets.forEach((row) => this.toggleRow(row, false));
  }

  toggleRow(row, confirming) {
    if (!row) return;

    const normal = row.querySelector('[data-members-normal]');
    const confirm = row.querySelector('[data-members-confirm]');
    if (normal) normal.hidden = confirming;
    if (confirm) confirm.hidden = !confirming;
  }
}
